<template>
  <site-banner pagina="contato" />

  <div class="contato-lista">
    <custom-lista
      class="contato-lista"
      :titulo="titulo"
      :itens="locale == 'es' ? contatos_es : contatos_pt"
      width="300"
      height="auto"
    />
  </div>

  <site-pesquisa />
</template>

<script setup>
const { t, locale } = useI18n();
const titulo = t("Entre em contato conosco");

// Português
const contatos_pt = [
  {
    imagem: "contato-info-fone",
    local: true,
    titulo: "0800 718 7886",
    texto: "Telefone e Whatsapp",
    class: "contato-cartao",
  },
  {
    imagem: "contato-info-mail",
    local: true,
    titulo: "contato@sorrifacil.com.br",
    texto:
      "Quer fazer parte da nossa equipe?#Envie seu currículo para recrutamento@sorrifacil.com.br",

    class: "contato-cartao",
  },
  {
    imagem: "contato-info-horario",
    local: true,
    titulo: "Horário de atendimento",
    texto:
      "Dias úteis: 8:00 às 20:00 Sábados: 8:00 às 14:00 (sem fechar ao meio dia)",
    class: "contato-cartao",
  },
];

// Espanhol
const contatos_es = [
  {
    imagem: "contato-info-fone",
    local: true,
    titulo: "+598 96 002 300",
    texto: "Teléfono y Whatsapp",
    class: "contato-cartao",
  },
  {
    imagem: "contato-info-mail",
    local: true,
    titulo: "montevideo1@sorrifacil.com",
    texto:
      "¿Quieres formar parte de nuestro equipo?#Envía tu currículum para montevideo1@sorrifacil.com",
    class: "contato-cartao",
  },
  {
    imagem: "contato-info-horario",
    local: true,
    titulo: "Horario de apertura",
    texto:
      "De lunes a viernes: 8:00 a 19:00 Sábado 8:00 a 14:00 (sin cerrar al mediodía)",
    class: "contato-cartao",
  },
];

useSeoMeta({
  title: t("Contatos da ") + t("sorrifacil"),
  ogTitle: t("Contatos da ") + t("sorrifacil"),
  description: t("Entre em contato com a ") + t("sorrifacil"),
  ogDescription: t("Entre em contato com a ") + t("sorrifacil"),
});
</script>

<script>
export default {
  name: "ContatoPagina",
};
defineI18nRoute({
  paths: {
    pt: "/contato",
    es: "/contacto",
  },
});
</script>
